import $ from "jquery";

const CARDS_PER_PAGE = 8;
const CARDS_PER_LOAD = 4;

const sectionInstances = [];

function initWebStories($section) {
    const $grid     = $section.find(".webstories__grid");
    const $loadMore = $section.find(".js-webstory-loadmore");
    const $loadLess = $section.find(".js-webstory-loadless");
    const $allCards = $grid.find(".js-webstory-card");
    let activeFilter = "all";
    let visibleCount = 0;

    function getFiltered() {
        if (activeFilter === "all") {return $allCards;}
        return $allCards.filter(function () {
            return ($(this).data("category") || "").trim().toLowerCase() === activeFilter;
        });
    }

    function updateButtons($f) {
        const hasMore     = visibleCount < $f.length;
        const isExpanded  = visibleCount > CARDS_PER_PAGE;

        // Mutually exclusive: Load More takes priority while hidden cards remain
        if (hasMore) {
            $loadMore.removeClass("webstories__load-more--hidden");
            $loadLess.addClass("webstories__load-more--hidden");
        } else if (isExpanded) {
            $loadMore.addClass("webstories__load-more--hidden");
            $loadLess.removeClass("webstories__load-more--hidden");
        } else {
            $loadMore.addClass("webstories__load-more--hidden");
            $loadLess.addClass("webstories__load-more--hidden");
        }
    }

    function render() {
        $allCards.addClass("webstories__card--hidden");
        const $f = getFiltered();
        $f.slice(0, CARDS_PER_PAGE).removeClass("webstories__card--hidden");
        visibleCount = Math.min(CARDS_PER_PAGE, $f.length);
        updateButtons($f);
    }

    $loadMore.on("click", function () {
        const $f     = getFiltered();
        const toShow = $f.slice(visibleCount, visibleCount + CARDS_PER_LOAD);
        toShow.removeClass("webstories__card--hidden");
        visibleCount += toShow.length;
        updateButtons($f);
    });

    $loadLess.on("click", function () {
        const $f = getFiltered();
        // Collapse back to first page
        $f.slice(CARDS_PER_PAGE).addClass("webstories__card--hidden");
        visibleCount = Math.min(CARDS_PER_PAGE, $f.length);
        updateButtons($f);
    });

    $grid.on("click", ".js-webstory-card", function (e) {
        // 1. Let native browser workflows handle modifier keys or middle-clicks
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) {return;}

        const target = ($(this).data("target") || "_self").trim();

        // 2. CRITICAL FIX: If target is '_blank', let the native <a> HTML tag
        // handle the link opening cleanly. Do not intercept it or trigger window.open() here.
        if (target === "_blank") {
            // Stop our event from bubbling up to any secondary AEM global clientlib scripts
            e.stopPropagation();
            return;
        }

        // 3. For standard '_self' navigation, intercept and route explicitly
        e.preventDefault();
        e.stopPropagation();

        const path = $(this).data("link");
        if (!path) {return;}

        const url = path.endsWith(".html") ? path : path + ".html";

        // Wipe AMP story progress (localStorage + sessionStorage) so the story
        // always opens from slide 1. amp-story 1.0 uses localStorage key
        // "amp-story-saved-progress_v1" to track the last-visited page.
        sessionStorage.clear();
        try {
            Object.keys(localStorage).forEach(function (key) {
                if (key.indexOf("amp-story") !== -1 || key.indexOf("i-amphtml") !== -1) {
                    localStorage.removeItem(key);
                }
            });
        } catch (e) { /* localStorage blocked — safe to ignore */ }

        window.location.href = url;
    });

    render();

    return {
        setFilter: function (filter) {
            activeFilter = (filter || "all").trim().toLowerCase();
            render();
        }
    };
}

$(document).ready(function () {
    // Clear AMP story progress on every listing page load so stories always
    // open from slide 1 — covers both card-click and browser back-button flows.
    // amp-story 1.0 persists last-visited page in localStorage under
    // "amp-story-saved-progress_v1"; wipe any amp-story keys to force a reset.
    sessionStorage.clear();
    try {
        Object.keys(localStorage).forEach(function (key) {
            if (key.indexOf("amp-story") !== -1 || key.indexOf("i-amphtml") !== -1) {
                localStorage.removeItem(key);
            }
        });
    } catch (e) { /* localStorage blocked in some contexts — safe to ignore */ }

    $(".webstories").each(function () {
        sectionInstances.push(initWebStories($(this)));
    });

    // Tab click — filter cards in-place, no page navigation
    $(document).on("click", ".js-webstory-tab", function () {
        const $tab  = $(this);
        const filter = ($tab.data("filter") || "all").toString().trim();

        $(".js-webstory-tab").removeClass("webstories__tab--active");
        $tab.addClass("webstories__tab--active");

        sectionInstances.forEach(function (inst) {
            inst.setFilter(filter);
        });
    });
});
